import DateRange from "@/components/DateRange";
import DatePicker from "@/components/DatePicker";
import PdShopList from "@/components/pd/common/ShopList";
import PdShopMultipleList from "@/components/pd/common/ShopMultipleList";
import Vue from 'vue';

const registerComponent = () =>{
    Vue.component('dateRange', DateRange)
    Vue.component('datePicker', DatePicker)
    Vue.component('pdShopList', PdShopList)
    Vue.component('pdShopMultipleList', PdShopMultipleList)
}
export default {
    registerComponent
}